import React from "react";
import { ReportingHome } from "components/Reports";

const Cnt_Reports: React.FC<any> = (props) => {
  return <ReportingHome/>
};

export default Cnt_Reports;
